module.exports = __webpack_public_path__ + "img/border_rectangle2.932a86a0.svg";